// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import EmailPreviewController from "./email_preview_controller";
application.register("email-preview", EmailPreviewController);

import FreeInvoiceController from "./free_invoice_controller";
application.register("free-invoice", FreeInvoiceController);

import FitDocumentController from "./fit_document_controller";
application.register("fit-document", FitDocumentController);

import PdfDownloadController from "./pdf_download_controller";
application.register("pdf-download", PdfDownloadController);

import LivePreviewController from "./live_preview_controller";
application.register("live-preview", LivePreviewController);

import ChoicesController from "./choices_controller";
application.register("choices", ChoicesController);

import DismissableController from "./dismissable_controller";
application.register("dismissable", DismissableController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);
application.register("railsui-dropdown", DropdownController);

import PaddleController from "./paddle_controller";
application.register("paddle", PaddleController);

import DropzoneController from "./dropzone_controller";
application.register("dropzone", DropzoneController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import PhoneController from "./phone_controller";
application.register("phone", PhoneController);

import ClientTypeController from "./client_type_controller";
import sidebar_controller from "./sidebar_controller";
import datepicker_controller from "./datepicker_controller";
import select_customer from "./invoices/select_customer";
import item_controller from "./invoices/item_controller";
import invoice_controller from "./invoice_controller";
import quote_controller from "./quote_controller.js";
import invoice_subscription_form_controller from "./invoice_subscription_form_controller.js";
import settings_controller from "./settings_controller.js";
import subscription_controller from "./subscription_controller.js";
import cookies_controller from "./cookies_controller.js";
import payment_terms_controller from "./invoices/payment_terms_controller.js";
import input_controller from "./items/input_controller.js";
import drawer_controller from "./drawer_controller.js";

application.register("client-type", ClientTypeController);
application.register("drawer", drawer_controller);
application.register("items--input", input_controller);
application.register("invoices--payment-terms", payment_terms_controller);
application.register("cookies", cookies_controller);
application.register("subscription", subscription_controller);
application.register("settings", settings_controller);
application.register("sidebar", sidebar_controller);
application.register("datepicker", datepicker_controller);
application.register("invoices--select-customer", select_customer);
application.register("invoices--item", item_controller);
application.register("invoice", invoice_controller);
application.register("quote", quote_controller);
application.register(
	"invoice-subscription-form",
	invoice_subscription_form_controller,
);

import WordDownloadController from "./word_download_controller";
application.register("word-download", WordDownloadController);

import CopyController from "./copy_controller";
application.register("copy", CopyController);
